import React from "react";
import authentication from "@irati/auth";
import { getInternalLinkFromString } from "@irati/utils/links";
import { StyledLink } from "./styled";
var LinkWrapper = function (_a) {
    var children = _a.children, companyNewsTile = _a.companyNewsTile;
    var url = companyNewsTile.config.url;
    if (url) {
        var internalUrl = getInternalLinkFromString(url, authentication.userTenant().subdomain);
        if (internalUrl) {
            return React.createElement(StyledLink, { href: internalUrl }, children);
        }
        return (React.createElement(StyledLink, { href: url, target: "_blank", rel: "noopener noreferrer" }, children));
    }
    return children;
};
export default LinkWrapper;
